
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      inLoading: false,
    }
  },
  head() {
    return {
      // 日本語に指定
      htmlAttrs: {
        lang: 'ja',
      },
    }
  },
  created() {
    this.setListener()
  },
  beforeDestroy() {
    // 多重バインド防止のため、イベントをoff（破棄）する
    this.$nuxt.$off('loadingFinish', this.loadingFinish)
  },
  mounted() {
    this.$nextTick(() => {
      this.$nuxt.$loading.start()
      this.inLoading = true
    })
  },
  methods: {
    setListener(): void {
      this.$nuxt.$on('loadingFinish', this.loadingFinish)
    },
    loadingFinish(duration: number): void {
      this.$nuxt.$loading.manualFinish(duration)
    },
  },
})
